import { Box, Tab, Tabs } from '@mui/material'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

const tabs = [
  { path: 'review-kpis', label: 'KPIs' },
  { path: 'marketing-invests', label: 'Marketing Invests' },
]

export function ReviewStatusIndex() {
  const location = useLocation()
  const navigate = useNavigate()
  const current = tabs.findIndex((t) => location.pathname.endsWith(t.path))
  return (
    <Box>
      <Tabs
        value={current >= 0 ? current : 0}
        onChange={(_, i: number) => navigate({ pathname: tabs[i]!.path, search: location.search })}
      >
        {tabs.map((t) => (
          <Tab key={t.path} label={t.label} />
        ))}
      </Tabs>
      <Outlet />
    </Box>
  )
}
